import React from 'react';
import { HandicapBoatList } from '../boatList/HandicapBoatList';
import { AboutPage } from '../aboutPage/AboutPage';
import { HandicapTable } from '../handicapTable/HandicapTable';
import { Container } from 'react-bootstrap';
import { NavEvent } from '../nav/NavEvent';
import { Import } from '../importExport/ImportContainer';
import { Export } from '../importExport/ExportContainer';
import { GroupList } from '../groupList/GroupList';
import { useFeatureTracking } from '../../hooks/usePageTracking';

export interface ContentContainerProps {
  content: NavEvent;
}


function pickContent(content: NavEvent) {
  switch (content) {
  case NavEvent.ABOUT:
    return <AboutPage />;
  case NavEvent.GROUPS:
    return <GroupList />;
  case NavEvent.BOATS:
    return <HandicapBoatList />;
  case NavEvent.TABLE:
    return <HandicapTable />;
  case NavEvent.IMPORT:
    return <Import />;
  case NavEvent.EXPORT:
    return <Export />;
  }
}

export function ContentContainer(props: ContentContainerProps) {
  // Track feature usage based on the current content
  const getFeatureName = (content: NavEvent): string => {
    switch (content) {
    case NavEvent.ABOUT:
      return 'about_page';
    case NavEvent.GROUPS:
      return 'group_management';
    case NavEvent.BOATS:
      return 'boat_list';
    case NavEvent.TABLE:
      return 'handicap_table';
    case NavEvent.IMPORT:
      return 'data_import';
    case NavEvent.EXPORT:
      return 'data_export';
    default:
      return 'unknown_feature';
    }
  };

  useFeatureTracking(props.content, getFeatureName(props.content));

  return <Container className="mb-5">
    {pickContent(props.content)}
  </Container>;
}
